export default __webpack_public_path__ + "static/3-0a8d12ed3ff9352e937a8afabaad5a1f.png";